import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Injectable } from '@angular/core';
import { ToastOptions } from 'ng2-toastr';



export class CustomOption extends ToastOptions {
    animate = 'flyRight'; // you can override any options available
    newestOnTop = false;
    showCloseButton = true;
}


@Injectable()
export class ToastrService {
    constructor(public toastr: ToastsManager) {
    }

    // Success Type
    typeSuccess(msg, opts = {}) {
        this.toastr.success(msg, 'Success!', opts);
    }

    // Success Type
    typeInfo(msg, title?) {
        this.toastr.info(msg, (title || ''));
    }

    // Success Type
    typeWarning() {
        this.toastr.warning('My name is Inigo Montoya. You killed my father, prepare to die!');
    }

    // Success Type
    typeError(msg) {
        this.toastr.error(msg, 'Error!');
    }

    // Custom Type
    typeCustomSuccess(msg) {

        var contentSuccess= '<p class="customToastSuccess customToastBasic"><img src="../../assets/img/success_icon.png" style="margin-right:8px">'+msg+'</p>';
        this.toastr.custom(contentSuccess,null, { enableHTML: true });
    }
    typeCustomError(msg) {
        var contentSuccess= '<p class="customToastError customToastBasic"><img src="../../assets/img/error_icon.png" style="margin-right:8px">'+msg+'</p>';
        this.toastr.custom(contentSuccess,null, { enableHTML: true });
    }

    // Timeout
    timeout() {
        this.toastr.error('I do not think that word means what you think it means.', 'Timeout!', { "toastLife": 2000 });
    }

    //Dismiss toastr on Click
    dismissToastOnClick(msg, title?) {
        this.toastr.info(msg, (title || ''), { dismiss: 'click' });
    }

    // Dismiss Toast controlled code
    dismissToastControlled() {
        this.toastr.success('You are awesome!', 'Success!', { dismiss: 'controlled' })
            .then(toast => {
                setTimeout(() => {
                    this.toastr.dismissToast(toast);
                }, 10000);
            });
    }

    // Remove current toasts using animation
    clearToast() {
        this.toastr.clearAllToasts()
    }

    // Show close button
    showCloseButton() {
        this.toastr.info('Have fun storming the castle!', 'Miracle Max Says', { showCloseButton: true });
    }

    // Enable  HTML
    enableHtml() {
        this.toastr.info('<i>Have fun <b>storming</b> the castle!</i>', 'Miracle Max Says', { enableHTML: true });
    }

    // Title Class
    titleClass() {
        this.toastr.info('Have fun storming the castle!', 'Miracle Max Says', { titleClass: 'h3' });
    }

    // Message Class
    messageClass() {
        this.toastr.info('Have fun storming the castle!', 'Miracle Max Says', { messageClass: 'text-uppercase' });
    }

}


// WEBPACK FOOTER //
// ./public/app/_services/toastr.service.ts